module.exports = __webpack_public_path__ + "static/media/37_A.4b5ab6ea.png";